export default [
  {
    path: "/simplePhoto",
    component: () => import("@/views/simplePhoto/index"),
    children: [
      {
        path: "home",
        component: () => import("@/views/simplePhoto/home"),
        meta: {
          title: "随手拍"
        }
      },
      {
        path: "phonelist",
        component: () => import("@/views/simplePhoto/phonelist"),
        meta: {
          title: "政府服务热线"
        }
      },
      {
        path: "submit",
        component: () => import("@/views/simplePhoto/submit"),
        meta: {
          title: "事件上报",
          keepAlive: true
        }
      },
      {
        path: "history",
        component: () => import("@/views/simplePhoto/history"),
        meta: {
          title: "上报记录"
      
        }
      },
      {
        path: "detail",
        component: () => import("@/views/simplePhoto/detail"),
        meta: {
          title: "事件详情"
        }
      },
      {
        path: "map",
        component: () => import("@/views/simplePhoto/selectLocation"),
        meta: {
          title: "选择位置"
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/simplePhoto.js